import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: "adapt-organisations-dashboard-page",
    templateUrl: "./organisations-dashboard-page.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class OrganisationsDashboardPageComponent {

}
